import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 56px 48px;
  box-sizing: border-box;
  overflow-y: auto;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.7;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 32px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 56px;
`;

export const MacroTitle = styled.div`
  color: ${({ theme }) => theme.text.input};
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`;

export const Link = styled.div`
  color: ${({ theme }) => theme.text.brand};
  font-family: "PP Formula";
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;
